export const useKakao = () => {
  const initKakao = () => {
    if (!window.Kakao) {
      console.error("Kakao SDK not loaded");
      return;
    }

    if (!window.Kakao.isInitialized()) {
      window.Kakao.init(import.meta.env.VITE_KAKAO_JS_KEY);
    }
  };

  return {
    initKakao,
  };
};
